import { render, staticRenderFns } from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=template&id=8861c2e2&scoped=true"
import script from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&lang=ts"
export * from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=script&lang=ts"
import style0 from "./CombinationsConfiguratorSelectorPopup.vue?vue&type=style&index=0&id=8861c2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8861c2e2",
  null
  
)

export default component.exports